import React, { useCallback } from "react";
import { useUpdateHomework } from '@widgets/appointment/api/useUpdateHomework';
import { MaterialComposer } from "@widgets/appointment/ui/material-composer/material-composer";

export const EditNote = ({ homework, onSuccess, appointmentId }) => {
  const { mutateAsync: editNote } = useUpdateHomework(appointmentId);

  const handleSubmit = useCallback(
    ({ text, attachments, existingFileIds }) =>
      editNote({
        appointmentId,
        homeworkId: homework.id,
        data: {
          task: text || null,
        },
        attachments,
        filesId: existingFileIds,
      }),
    [appointmentId, editNote, homework?.id]
  );

  return (
    <MaterialComposer
      submitLabel="Сохранить"
      startExpanded
      initialText={homework?.task || ""}
      initialAttachments={homework?.attachments || []}
      onSubmit={handleSubmit}
      onCancel={onSuccess}
      showCollapseButton={false}
    />
  );
};
